export abstract class AbstractStaticConfig {
  abstract get spinedReels(): number[][];
  abstract get noWinReels(): number[][];
}
